import React from "react";
import styles from "./AppSkeleton.module.css";

const AppSkeleton = ({
  variant = "", // "table"
  size = "1rem",
  headerSize = "1.25rem",
  rows = 1,
  cols = 1,
  ...rest
}) => {
  const rowsArr = Array(rows).fill("");
  const colsArr = Array(cols).fill("");

  return variant === "table" ? (
    <table className="table table-sm table-bordered">
      <thead className="bg-transparent">
        <tr>
          {colsArr.map((td, j) => {
            return (
              <th scope="col" key={j}>
                <div
                  className={styles.sk_header}
                  style={{ height: headerSize }}></div>
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {rowsArr.map((tr, i) => {
          return (
            <tr key={i}>
              {colsArr.map((td, j) => {
                return (
                  <td key={j}>
                    <div
                      className={styles.sk_col}
                      style={{ height: size }}></div>
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  ) : (
    <React.Fragment>
      {rowsArr.map((r) =>
        colsArr.map((c) => <div className={styles.sk_col}></div>)
      )}
    </React.Fragment>
  );
};

export default AppSkeleton;
